import { logoFlipFlop } from "assets";
import { Popover, PopoverContent, PopoverTrigger } from "components/app/popover/Popover";

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "components/ui/tooltip";
import { MessageCircle } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import SubChatHeader from "./sub-chat-header/SubChatHeader";

export default function ChatHeader() {
  const { t } = useTranslation();
  const [openPopoverIndex, setOpenPopoverIndex] = useState<number | null>(null);

  return (
    <Popover
      onOpenChange={(isOpen) => {
        if (!isOpen) setOpenPopoverIndex(null);
      }}
    >
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger className="hover:bg-gray-200  dark:hover:bg-primary rounded-full w-12 h-12 p-3" asChild>
            <PopoverTrigger asChild>
              <MessageCircle className="cursor-pointer" />
            </PopoverTrigger>
          </TooltipTrigger>
          <TooltipContent align="start" alignOffset={10}>
            <p>{t("Message")}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <PopoverContent isShowBtnXClose={true} className="w-80">
        <div className="grid gap-4">
          <div className="space-y-2">
            <h4 className="font-medium cursor-pointer">Message</h4>
            <div className="">
              {[...Array(10)].map((_, index) => (
                <SubChatHeader index={index} setOpenPopoverIndex={setOpenPopoverIndex} openPopoverIndex={openPopoverIndex} />
              ))}
            </div>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
